import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { BehaviorSubject, from, Observable, of as observableOf } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

import { ConfigService } from '@app/core/config.service';

@Injectable({
  providedIn: 'root',
})
export class MapsApiLoaderService {
  readonly loader: Loader;
  private apiLoaded = new BehaviorSubject<boolean>(false);
  private loadingInProgress = false;

  constructor(private config: ConfigService) {
    this.loader = new Loader({
      apiKey: config.json.googlePlacesKey,
      version: 'weekly',
      libraries: ['places'],
    });
  }

  // Returns the same observable to all callers
  load$(): Observable<boolean> {
    if (this.apiLoaded.value && window.google?.maps) {
      return this.apiLoaded.asObservable();
    }

    if (!this.loadingInProgress) {
      this.loadingInProgress = true;
      from(this.loader.load())
        .pipe(
          tap(() => {
            this.apiLoaded.next(true);
          }),
          catchError(() => {
            this.apiLoaded.next(false);
            return observableOf(false);
          }),
          finalize(() => {
            this.loadingInProgress = false;
          }),
        )
        .subscribe();
    }

    return this.apiLoaded.asObservable();
  }
}
